import Rails from "@rails/ujs";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    if (!this.hasInputTarget) {
      console.log("No input target");
      return;
    } else {
      window.intlTelInput(this.inputTarget, {
        utilsScript:
          "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
        initialCountry: "us",
        nationalMode: true,
        hiddenInput: "primary_phone_number",
        autoPlaceholder: "aggressive",
      });
    }
  }
}
